module.exports = __webpack_public_path__ + "static/media/dropdown_outline.1f836211.svg";